const empresa = 6;

const getDados = () => {

    if (empresa === 0) { // Homologacao
        return {
            API_URL: 'http://192.168.1.5:3007/api',
            OAPI_URL: 'http://192.168.1.5:3007/oapi'

        }
    }
    if (empresa === 1) {// SENAP
        return {
            API_URL: 'https://sdrsp.sdrweb.net.br/api',
            OAPI_URL: 'https://sdrsp.sdrweb.net.br/oapi'

        }
    }
    if (empresa === 2) {// MAIS UNIVIDA
        return {
            API_URL: 'https://bolunivida.sdrweb.net.br/api',
            OAPI_URL: 'https://bolunivida.sdrweb.net.br/oapi'
        }
    }
    if (empresa === 3) {// Nova Alianca
        return {
            API_URL: 'https://bolnalianca.sdrweb.net.br/api',
            OAPI_URL: 'https://bolnalianca.sdrweb.net.br/oapi'


        }
    }
    if (empresa === 4) {// OURO PAX
        return {
            API_URL: 'https://gestorpsaoluiz.sdrweb.net.br/api',
            OAPI_URL: 'https://gestorpsaoluiz.sdrweb.net.br/oapi'


        }
    }
    if (empresa === 5) {// Pax Aparecida
        return {
            API_URL: 'https://gestorbol.paxaparecida.com.br/api',
            OAPI_URL: 'https://gestorbol.paxaparecida.com.br/oapi'


        }
    }
    if (empresa === 6) {// Senap 2
        return {
            API_URL: 'https://bolsenap.sdrweb.net.br/api',
            OAPI_URL: 'https://bolsenap.sdrweb.net.br/oapi'
        }
    }

    if (empresa === 7) {// Pafam
        return {
            API_URL: 'https://gestorbol.pafam.com.br/api',
            OAPI_URL: 'https://gestorbol.pafam.com.br/oapi'
        }
    }

}

export default getDados();




// WEBPACK FOOTER //
// ./src/consts.js